import React, { Component } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Button from '../blocks/button/Button';
import SliderImg from './blocks/slider/SliderSmall';
import Comments from '../blocks/review/ReviewLanding';
import UserSections from '../blocks/user-sections/UserSections';

// import BeforeAdditional from './blocks/BeforeAdditional';
import AfterAdditional from './blocks/AfterAdditional';
import BeforeDescription from './blocks/BeforeDescription';
// import BeforeAbout from './blocks/BeforeAbout';

// import AfterAbout from './blocks/AfterAbout';
import AfterVideo from './blocks/AfterVideo';
import SubscribeToNews from './blocks/SubscribeToNews';

// import { newEmailHandler }from '../validators/form-validators';
import { postParticipant } from '../actions/google-form-action';
import { clearFields } from '../actions/field-action';

import {
  NOT_REGISTERED,
  ALREADY_REGISTERED,
} from './blocks/SubscribeToNews';

import './style.css';


class Landing extends Component {
  handleFormSubmit(type, event) {
    event.preventDefault();
    let validateSuccess = true;
    for (const key of Object.keys(this.refs)) {
      if (!this.refs[key].onValidate() && key.indexOf(type) > -1) {
        validateSuccess = false;
      }
    }
    if (validateSuccess) {
      let formData = new FormData(event.target);
      this.props.postParticipant(formData);
      for (const key of Object.keys(this.refs)) {
        if (key.indexOf(type) > -1) {
          this.refs[key].clearField();
        }
      }
    }
  }

  render() {
    let regBtn = null;
    if (!this.props.participantView.userShortView && this.props.withServer && !this.props.registrationClosed) {
      regBtn = (
        <Link to='/register'>
          <Button styleClasses={['landing__button-register']}>
            РЕГИСТРАЦИЯ
          </Button>
        </Link>
      );
    }

    return (
      <div className='landing'>
        <header className='banner clearfix'>
          <img className='banner__logo' src='/static/images/logo.png' alt='Logo'/>
          {/*<div className='banner__place'>*/}
            {/*ОмГУ, 1 корпус (пр. Мира, 55а)*/}
          {/*</div>*/}
          <div className='banner__date'>
             Конференция прошла 24 сентября’17<br />
             Следующая в 2018 году
            {/*Корпус ОмГТУ на ул. Красногвардейская, 9<br />*/}
            {/*24 сентября 2017 в 10:00*/}
          </div>

          <div className='banner__bg-persons'>
            <span className='banner__bg-person banner__bg-person_girl'>
            &nbsp;</span>
            <span className='banner__bg-person banner__bg-person_boy'>&nbsp;
            </span>
          </div>
        </header>

        <SubscribeToNews
          registrationStatus={!this.props.participantRegisterSuccess ? NOT_REGISTERED : ALREADY_REGISTERED}
          onSubmit={this.handleFormSubmit.bind(this, 'participant')}
          submitDisabled={this.props.participantDataSending}
        />

        <UserSections />

        <div>
          {regBtn}
        </div>

        <BeforeDescription/>
        {/*<AfterAbout />*/}
        {/*<BeforeAbout/>*/}
        <AfterVideo />

        {/*<BeforeAdditional/>*/}
        <AfterAdditional />
        <SliderImg />

        {/*<div>
          {regBtn}
        </div>*/}

        <Comments isRand={true}/>
        <div>
          <Link to='reviews'>
            <Button styleClasses={['landing__button-reviews']}>
              ВСЕ ОТЗЫВЫ&nbsp;&rarr;
            </Button>
          </Link>
        </div>

          <SubscribeToNews
              registrationStatus={!this.props.participantRegisterSuccess ? NOT_REGISTERED : ALREADY_REGISTERED}
              onSubmit={this.handleFormSubmit.bind(this, 'participant')}
              submitDisabled={this.props.participantDataSending}
          />

        <div>
          {regBtn}
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  participantView: state.participant.participantView,
  withServer: state.participant.withServer,
  registrationClosed: state.participant.registrationClosed,
  participantDataSending: state.googleFormReducer.participantDataSending,
  participantRegisterSuccess: state.googleFormReducer.participantRegisterSuccess
});

const mapDispatchToProps = (dispatch) => ({
  postParticipant: bindActionCreators(postParticipant, dispatch),
  clearFields: bindActionCreators(clearFields, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/landing/Landing.js